module.exports = __webpack_public_path__ + "static/media/chess-rook-alt.43668de8.svg";